// extracted by mini-css-extract-plugin
export default {"paper":"SharePopover_paper__SD1Yi","shareButton":"SharePopover_shareButton__OFEaO","shareIcon":"SharePopover_shareIcon__PkAJc"};